import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actCreateVehicleCategoriesFailed,
  actCreateVehicleCategoriesSuccess,
  MASTER_CREATE_VEHICLE_CATEGORIES,
} from '../../actions/vehicle-categories'
import { apiCreateVehicleCategories } from '../../apis/vehicle-categories'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doCreate(action) {
  try {
    const response = yield call(apiCreateVehicleCategories, action?.payload)

    if (response?.statusCode === 200) {
      yield put(actCreateVehicleCategoriesSuccess({ data: response.data }))
      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }
      addNotification(
        'vehicleCategories.notification.createSuccess',
        NOTIFICATION_TYPE.SUCCESS,
      )
    } else {
      addNotification(response?.message, NOTIFICATION_TYPE.ERROR)
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actCreateVehicleCategoriesFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchCreate() {
  yield takeLatest(MASTER_CREATE_VEHICLE_CATEGORIES, doCreate)
}
